import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { Grid_BookingModel } from "./Grid_BookingModel";

export class Grid_BookingFindResultModel extends BaseFindResult {

    public getDataItem(i: number): Grid_BookingModel {
        let o: Grid_BookingModel = Object.assign(new Grid_BookingModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): Grid_BookingModel[] {

        let d: Grid_BookingModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: Grid_BookingModel = Object.assign(new Grid_BookingModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
